import { Navigate } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';
import { isAdmin } from '@/constants/roles';

interface RequireAdminProps {
    children: React.ReactNode;
    redirectTo?: string;
}

/**
 * Route guard for the admin panel — only the Admin role gets in.
 * Redirects to the specified path (default: home) otherwise.
 */
export function RequireAdmin({ children, redirectTo = '/' }: RequireAdminProps) {
    const { user, isReady } = useAuth();

    // Wait for auth to be ready before checking
    if (!isReady) {
        return null; // Or a loading spinner
    }

    const hasAccess = isAdmin(user?.metadata?.organization_roles);

    if (!hasAccess) {
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
}
